import type { PropsWithChildren } from 'react'

import { space } from '@sunwebgroup/ui-components'
import { ScrollArea } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, styled } from 'styled-components'
import { DropdownMultiselectContext } from './context'

const Wrapper = styled.div<{ $asDialog: boolean | undefined }>`
  overflow-y: auto;
  min-height: 0;
  padding: ${space('primitives_space_8')}; //Should be 12, but 8 is used because we added 4px to show focus correctly. See destinationFilder PaddingFocus style component

  ${({ $asDialog }) =>
    $asDialog
    && css`
      padding: 0;
    `}
`

export function Options({ children }: PropsWithChildren) {
  const { asDialog } = React.use(DropdownMultiselectContext)
  return (
    <Wrapper $asDialog={asDialog}>
      <ScrollArea.Root>
        <ScrollArea.Viewport>
          {children}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar orientation="vertical">
          <ScrollArea.Thumb />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </Wrapper>
  )
}
